import { Component } from '@angular/core';
import * as moment from 'moment-timezone';

@Component({
  selector: 'production-progress-text-editor',
  template: `
    <label *ngIf="showInput">{{ value }} </label>
    <input
      *ngIf="!showInput"
      #input
      type="number"
      (keypress)="onKeyPress($event)"
      maxlength="5"
      pattern="[0-9]"
      [(ngModel)]="value"
      class="grid-cell-edit-layout "
      (change)="textUpdated()"
      autofocus
    />
  `,
  styles: [
    `
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    .grid-cell-edit-layout {
      width: 100%;
      border: 1px solid black;
    }
    .invalid-text {
      border: 2px solid red !important;
    }
    `,
  ],
})
export class ProdProgressFinalEditComponent {
  public params: any;
  showInput = true;
  value: any;
  isEmpty = true;
  isPastDay: boolean;
  reportdate = new Date();  // Current date
  isToday: boolean;
  shiftOneEnded = false;
  timezone;



  constructor() { }
// prod
agInit(params: any): void {
  localStorage.setItem('isFinal', 'false');
  this.params = params;

  // Check shift one status
  this.shiftOneEnded = localStorage.getItem('isShiftoneEnded') === 'true';

  // Assign the value from params if editing 'final'
  if (params.column === 'final') {
    params.data.Final = this;
    this.value = params.data.final;
    this.isEmpty = !!this.value;
  }

  // Get timezone from localStorage or fallback
  this.timezone = localStorage.getItem('timezone') || 'UTC';

  // Get today's date in correct timezone
  const today = moment().tz(this.timezone).startOf('day');

  // Parse the actual_date in timezone context
  const actualDate = moment.tz(this.params?.data.actual_date, 'MM/DD/YYYY', this.timezone).startOf('day');

  console.log("Today:", today.format());
  console.log("Actual Date:", actualDate.format());

  // Set flags
  this.isPastDay = actualDate.isBefore(today, 'day');
  this.isToday = actualDate.isSame(today, 'day');

  // Control input visibility
  if (this.params.data.checkedEditMode && this.isPastDay) {
    this.showInput = false;
  } else if (
    this.params.data.checkedEditMode &&
    this.isToday &&
    String(this.params.data.actual_shift) === '1' &&
    this.shiftOneEnded
  ) {
    this.showInput = false;
  } else {
    this.showInput = true;
  }
}

// agInit(params: any): void {
//   localStorage.setItem('isFinal', 'false');

//   let isShiftoneEnded = localStorage.getItem('isShiftoneEnded');
//   if (isShiftoneEnded === 'true') {
//     this.shiftOneEnded = true;
//   }


//   if (params.column === 'final') {
//     params.data.Final = this;
//     this.value = params.data.final;

//     this.isEmpty = !!this.value;
//   }

//   this.params = params;

//   // Get timezone from localStorage or fallback to UTC
//   this.timezone = localStorage.getItem('timezone') || 'UTC';

//   // Use timezone-aware 'today' and 'date'
//   const today = moment().tz(this.timezone);
//   console.log("Today's Date:", today.format('MM/DD/YYYY'));

//   // Make sure this.reportdate is set or fallback to now
//   const reportDate = this.reportdate ? moment(this.reportdate).tz(this.timezone) : moment().tz(this.timezone);
//   let date = reportDate.format('MM/DD/YYYY');
//   console.log("Report Date:", date);

//   // Assuming 'actual_date' is in the format 'MM/DD/YYYY' and parse with timezone
//   let actualDate = moment(this.params?.data.actual_date, 'MM/DD/YYYY').tz(this.timezone);
//   this.isToday = actualDate.isSame(moment(date, 'MM/DD/YYYY').tz(this.timezone), 'day');

//   console.log("Actual Date:", actualDate.format('MM/DD/YYYY'));

//   // Check if actualDate is before today in timezone
//   this.isPastDay = actualDate.isBefore(today, 'day');

//   if (this.params.data.checkedEditMode && this.isPastDay) {
//     this.showInput = false;
//   } else {
//     this.showInput = true;
//   }

//   if (this.params.data.checkedEditMode && this.isToday && String(this.params.data.actual_shift) === '1' && this.shiftOneEnded) {
//     this.showInput = false;
//   }
// }


  // agInit(params: any): void {
  //   localStorage.setItem('isFinal', 'false');
  //   let isShiftoneEnded = localStorage.getItem('isShiftoneEnded')
  //   if (isShiftoneEnded === 'true') {
  //     this.shiftOneEnded = true

  //   }



  //   console.log("inside review chnages--------------", params.column)
  //   // if (params.column === 'int_plan_volume') {
  //   //   params.data.intPlanVol = this;

  //   //   this.value = params.data.int_plan_volume;


  //   //   if (this.value) {
  //   //     this.isEmpty = false;
  //   //   } else {
  //   //     this.isEmpty = true;
  //   //   }
  //   // }
  //   if (params.column === 'final') {
  //     params.data.Final = this;

  //     this.value = params.data.final;


  //     if (this.value) {
  //       this.isEmpty = false;
  //     } else {
  //       this.isEmpty = true;
  //     }
  //   }

  //   // if (params.column === 'cumul_plan_net') {
  //   //   params.data.cumulPlanNet = this;
  //   //   this.value = params.data.cumul_plan_net;

  //   //   this.isEmpty = false;
  //   // } else {
  //   //   this.isEmpty = true;
  //   // }
  //   this.params = params;
  //   const today = moment();
  //   console.log("Today's Date:", today.format('MM/DD/YYYY'));
  //   let date = moment(this.reportdate).format('MM/DD/YYYY');
  //   console.log("Today's Date:", date);


    
  //   // Assuming 'actual_date' is in the format 'MM/DD/YYYY'
  //   let actualDate = moment(this.params?.data.actual_date, 'MM/DD/YYYY');
  //   this.isToday = actualDate.isSame(moment(date, 'MM/DD/YYYY'), 'day');

  //   console.log("Actual Date:", actualDate.format('MM/DD/YYYY'));
    
  //   // Check if actualDate is before today
  //   if (actualDate.isBefore(today, 'day')) {
  //     this.isPastDay = true;  // Show input if the actualDate is before today
  //   } else {
  //     this.isPastDay = false;  // Hide input for today's date or future dates
  //   }
    

  //   if (
  //     this.params.data.checkedEditMode && this.isPastDay


  //   ) {
  //     this.showInput = false;
  //   } else {
  //     this.showInput = true;
  //   }
  //   if (this.params.data.checkedEditMode && this.isToday && String(this.params.data.actual_shift) === '1' && this.shiftOneEnded) {
  //     this.showInput = false;
  //   }

  // }

  // called when the cell is refreshed
  refresh(params: any): boolean {
    this.params = params;
    return true;
  }

  public textUpdated() {
    console.log("textupadted")
    console.log(" outside inside if", this.params)


    localStorage.setItem('isFinal', 'true');
    if (this.params.column === 'final') {
      if (this.value !== this.params.data.final) {
        console.log(" outside inside if", this.params)

        this.params.data.final = this.value;
        this.params.data.Final = true;
        this.params.data.Updated = true;

      }
    } else {
      this.params.data.Final = this.value;
      this.params.data.Updated = false;

    }

    //prod issue chceking 
    





  }

  onKeyPress(event) {
    const charCode = event.charCode;
    // Allow digits only (0-9)
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
    if (event.target.value.length <= 4) {
      return true;
    } else {
      return false;
    }
  }
  stopTyping() {
    return false;
  }

}
